import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import '../styles/Profile.css'
import { useToasts } from 'react-toast-notifications'
import { set } from 'lodash'

export default function AdvancedSettings(props) {
    const [secretKey, setSecretKey] = useState('')
    const { t } = useTranslation()
    const { addToast } = useToasts()
    const [secretKeyError, setSecretKeyError] = useState('')

    useEffect(() => {
        setSecretKey(localStorage.getItem('secret_key') || '')
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!secretKey.trim()) {
            setSecretKeyError(t('required'))
            return
        }

        setSecretKeyError('')

        localStorage.setItem('secret_key', secretKey)
        setSecretKey('')

        addToast(t('yourSecretKeyIsSaved'), {
            appearance: 'success',
            autoDismiss: true,
        })
    }

    return (
        <div className="personal-info-container shadow-custom-soft">
            <div className="notes-title">{t('changeSecurityKey')} </div>

            <div className="advance-form">
                <form onSubmit={handleSubmit}>
                    <div className="advance-settings-label">{t('secretKey')}</div>
                    <label className="attention">
                        <div className="advance-settings-attention">
                            <b style={{ color: '#153c4f' }}>{t('Attention')}</b>: {t('toEnsureYourPrivacyThisKeyIsNotRecoverableAllYourNotesWillBeLostIfYouForgetThisKey')}
                        </div>{' '}
                    </label>
                    <input
                        type="password"
                        name="user_secret_key"
                        placeholder="* * * *"
                        value={secretKey}
                        onChange={(e) => {
                            setSecretKey(e.target.value)
                            if (secretKeyError) setSecretKeyError('')
                        }}
                    />
                    {secretKeyError && <span className="input-error-text">{secretKeyError}</span>}

                    <button className="generic-submit-button" style={{ marginTop: 44 }}>
                        {t('save')}
                    </button>
                </form>
            </div>
        </div>
    )
}
